/**
 * Funnel V2 Helper Functions
 * 
 * Local copy of helpers from main project to avoid import issues
 */

/**
 * Generate a unique edge ID
 */
export function generateEdgeId(sourceId: string, targetId: string): string {
    return `edge_${sourceId}_${targetId}_${Date.now()}`;
}

/**
 * Generate a unique node ID
 */
export function generateNodeId(type?: string): string {
    const timestamp = Date.now();
    const prefix = type ? `${type}_` : 'node_';
    return `${prefix}${timestamp}`;
}
